<template>
  <div class="keshijieshao">
    <van-tabs v-model="activeTitle" color="#318DF0" title-active-color="#318DF0">
      <van-tab v-for="(item, index) in deptList" :key="index" :title="item.deptName">
        <div class="img">
          <img class="img-bj" src="../../assets/images/beijingtu.png" alt="图片">
          <img class="child-img" src="../../assets/images/sanjia.png" alt="">
          <span class="child-title">{{ item.deptName }}</span>
        </div>
        <div v-if="item.content" class="contact" v-html="item.content" />
        <no-data v-else />
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
export default {
  name: 'Keshijieshao',
  data() {
    return {
      activeTitle: '',
      deptList: []
    }
  },
  created() {
    this._getList()
  },
  mounted() {},
  methods: {
    _getList() {
      this.$Apis.getDept({
        branch: 1,
        size: 99,
        hospital: 1010,
        status: 1
      }).then(res => {
        if (res.code === 200) {
          this.deptList = res.data.list
        }
      })
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less" scoped>
.keshijieshao {
  overflow: hidden;
  p {
    line-height: 1rem;
  }
  .img {
    margin: 10px;
    position: relative;
    .img-bj{
      width: 100%;
    }
    .child-img {
      position: absolute;
      width: 22%;
      left: 35%;
      top: 60%;
    }
    .child-title {
      position: absolute;
      color: #fff;
      font-size: 1.5em;
      top: 30%;
      left: 5%;
    }
  }
  .contact {
    margin: 10px;
    padding: 10px;
    line-height: 26px;
    color: #6a6a6a;
    background: #fff;
    text-indent: 2em;
    word-break: break-all;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, .1);
    border-radius: 5px;
      /deep/ img {
        display: block;
        width: calc(100vw - .4rem);
      }
  }
  /deep/.van-tabs__wrap {
    box-shadow: 0px 0px 10px rgba(0, 0, 0, .1);
    border-radius: 5px;
    margin: 10px;
  }
}
</style>
